import axios from 'axios';
import { message } from 'antd';
import {
  FEES_API,
} from '../../../constants/API';
import {
  CREATE_FEE_LOADING
} from '../types';
import getFees from './getFees';

function createLocation(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_FEE_LOADING,
        creatingFee: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        await axios.post(FEES_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        dispatch({
          type: CREATE_FEE_LOADING,
          creatingFee: false
        });
        await dispatch(getFees());
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_FEE_LOADING,
          creatingFee: false
        });
        console.log(e);
      }
  }
}
export default createLocation;
